import { render, staticRenderFns } from "./punkstar.vue?vue&type=template&id=44e29320&scoped=true"
import script from "./punkstar.vue?vue&type=script&lang=js"
export * from "./punkstar.vue?vue&type=script&lang=js"
import style0 from "./punkstar.vue?vue&type=style&index=0&id=44e29320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e29320",
  null
  
)

export default component.exports